// TODO: move helper functions from FileHelpers.jsx

export const getFilenameParts = (
  filename: string
): { baseName: string; extension: string | null } => {
  const bits = filename.split('.');
  let extension = null;

  if (bits.length > 1) {
    extension = bits.pop() || null;
  }

  return {
    baseName: bits.join('.'),
    extension,
  };
};

export const filenameWithNewExtension = (
  filename: string,
  extension: string
): string => {
  const fileNameParts = getFilenameParts(filename);
  const fileNameWithoutExtension = fileNameParts.baseName;
  return [fileNameWithoutExtension, extension].join('.');
};

// Include workaround for creating file for IE, since IE does not support
// File API.
// Code snippet from https://pqina.nl/blog/rename-a-file-with-javascript/
export const createFile = (
  bits: BlobPart[],
  name: string,
  type: string
): File | Blob => {
  try {
    // If this call fails, we go for Blob
    return new File(bits, name, { type });
  } catch (e) {
    // If we reach this point a new File could not be constructed
    const myBlob = new Blob(bits);

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    myBlob.lastModified = new Date();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    myBlob.name = name;
    return myBlob;
  }
};

// rename file if filename by returning new File object
export const renameFile = (file: File, newName: string): File | Blob =>
  createFile([file], newName, file.type);
